// extracted by mini-css-extract-plugin
export default {"rgpd":"Rgdp_rgpd__OmriX","banner":"Rgdp_banner__w919z","text":"Rgdp_text__DqLdE","actions":"Rgdp_actions__ab3eh"};